import React from 'react';
// import logo from './logo.svg';
import Navbar from "./component/navbar";
import Content from "./component/content";
 
 
import './App.css';

function App() {
 
  return (
   <>
   <Navbar></Navbar>
   <Content></Content>
   </>    
  );
}

export default App;
